// Keep synced with enum on sendBulkEmails task
export enum HolidayRequestStatuses {
  REQUESTED = "requested",
  APPROVED = "approved",
  DECLINED = "declined",
}
